import React from 'react';
import { Collapse } from 'src/ui/components/collapse/sports/05/Collapse';

export interface SectionHeaderPropsType {
    title: React.ReactNode;
    dataTest?: string;
}

export const SectionHeader = ({ title, dataTest }: SectionHeaderPropsType) => (
    <Collapse
        title={title}
        type='header'
        isOpen
        collapsible={false}
        dataTest={dataTest}
    />
);
